import { render } from "./CardAttachmentCard.vue?vue&type=template&id=afbb81b4&scoped=true"
import script from "./CardAttachmentCard.vue?vue&type=script&lang=js"
export * from "./CardAttachmentCard.vue?vue&type=script&lang=js"

import "./CardAttachmentCard.vue?vue&type=style&index=0&id=afbb81b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afbb81b4"]])

export default __exports__